import type { StripeAddressElementOptions } from "@stripe/stripe-js";
import { useMemo } from "react";

export const useAddressElementFields = () =>
  useMemo<StripeAddressElementOptions["fields"]>(
    () => ({
      // We never require the phone field.
      phone: "never",
    }),
    [],
  );
